import dayjs from "dayjs";
import { RouteSettings } from "../stores/RouteSettingsStore";
import { AddressItem } from "./GeocodeService"
import { EnvironmentName, IEnvironmentSetting } from "../stores/EnvironmenSettingStore";
import { SourceReferenceSystem } from "./RuteplanAPI";

export function GetStateFromUrl() {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const settings = params.get("settings");
    const from = params.get("from");
    const to = params.get("to");
    const via = params.get("via");
    const barriers = params.get("barriers");
    const environment = params.get("environment");

    const settingsParsed = settings ? JSON.parse(settings) as RouteSettings : undefined;
    const fromParsed = from ? JSON.parse(from) as AddressItem : undefined;
    const toParsed = to ? JSON.parse(to) as AddressItem : undefined;
    const viaParsed = via ? JSON.parse(via) as Array<AddressItem> : undefined;
    const barriersParsed = barriers ? JSON.parse(barriers) as Array<AddressItem> : undefined;
    const environmentParsed = environment ? environment as EnvironmentName : undefined;

    if (settingsParsed)  {
        settingsParsed.startTime = dayjs(settingsParsed.startTime);
        settingsParsed.outputSrs = SourceReferenceSystem.EPSG_4326
    }

    return {
        settings: settingsParsed,
        from: fromParsed,
        to: toParsed,
        via: viaParsed,
        barriers: barriersParsed,
        environment: environmentParsed
    }
}

export function UpdateURL(settings: RouteSettings, fromAddress: AddressItem, toAddress: AddressItem, viaPoints: Array<AddressItem>, barriers: Array<AddressItem>, environmentName: EnvironmentName) {    
    let url = new URL(window.location.href);
    const params = new URLSearchParams();
    params.append("settings", JSON.stringify(settings));
    params.append("from", JSON.stringify(fromAddress));
    params.append("to", JSON.stringify(toAddress));
    params.append("via", JSON.stringify(viaPoints));
    params.append("barriers", JSON.stringify(barriers));
    params.append("environment", environmentName)
    url.search = params.toString();
    window.history.pushState({}, "", url.toString());
}